import { render } from "./recipe.vue?vue&type=template&id=6d43636f&scoped=true"
import script from "./recipe.vue?vue&type=script&lang=js"
export * from "./recipe.vue?vue&type=script&lang=js"

import "./recipe.vue?vue&type=style&index=0&id=6d43636f&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d43636f"]])

export default __exports__